import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showBtnBody'
})
export class ShowBtnBodyPipe implements PipeTransform {

  transform(value: { }, ...args: unknown[]): unknown {
    return null;
  }

}
